import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AddOst } from 'src/app/logic/search-ost';
import { DisplayModal } from 'src/app/logic/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'add-tratto-popup',
  templateUrl: './add-tratto-popup.component.html'
})
export class AddTrattoPopupComponent implements OnInit {

  @Input() ost;
  @Input() feature;
  @Input() index;
  constructor(private store: Store<any>, private translate: TranslateService) { }

  ngOnInit() {
  }

  onClick() {
    if (this.index > -1) {
      this.store.dispatch(new AddOst({ ost: this.ost, position: this.index }));
    } else {
      this.translate.get('modal.poierror').subscribe(msg => {
        this.store.dispatch(new DisplayModal({
          type: 'confirm', data: {
            message: msg
          }
        }));
      });
    }
    this.feature.closePopup();
  }
}
